import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ForgotPass from './pages/ForgotPass';
import { NotFound } from './pages/NotFound';
import ShowHistory from './pages/ShowHistory';
import Verify from './pages/Verify';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login"/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/dashboard" element={<Navigate to="/dashboard/page/1"/>}/>
        <Route path="/dashboard/page" element={<Navigate to="/dashboard/page/1"/>}/>
        <Route path="/verify" element={<Verify/>}/>
        <Route path="/forgot" element={<ForgotPass/>}/>
        <Route path="/dashboard/page/:pageNumber" element={<Dashboard />}/>
        <Route path="/dashboard/history/:violation" element={<ShowHistory />}/>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router> 
  );
}

export default App;
